import type { EvidenceItem, IntervieweeDetail, MediaPreview } from "../domain/contracts";
import type { DownloadEvidenceItem } from "./media/mediaDownloadService";

export type EvidenceGroup = IntervieweeDetail["evidenceGroups"][number];
export type EvidenceGroupItem = EvidenceGroup["items"][number];
type PreviewEvidenceLink = Pick<EvidenceItem, "id" | "assetId">;

export function buildPreviewByAssetId(
  evidence: PreviewEvidenceLink[],
  previews: MediaPreview[],
): Map<string, MediaPreview> {
  const previewByEvidenceId = new Map(previews.map((preview) => [preview.evidenceId, preview]));
  const previewByAssetId = new Map<string, MediaPreview>();

  for (const item of evidence) {
    const preview = previewByEvidenceId.get(item.id);
    if (preview) {
      previewByAssetId.set(item.assetId, preview);
    }
  }

  return previewByAssetId;
}

export function buildDownloadItemsFromGroups(groups: EvidenceGroup[]): DownloadEvidenceItem[] {
  const items: DownloadEvidenceItem[] = [];
  for (const group of groups) {
    for (const item of group.items) {
      items.push(toDownloadEvidenceItem(group, item));
    }
  }
  return items;
}

export function toDownloadEvidenceItem(group: EvidenceGroup, item: EvidenceGroupItem): DownloadEvidenceItem {
  return {
    assetId: item.assetId,
    mediaType: item.mediaType,
    mimeType: item.mimeType,
    captionDefault: item.captionDefault,
    branchKind: item.branchKind ?? group.branchKind,
    itemIndex: item.itemIndex ?? group.itemIndex,
    detailIndex: item.detailIndex ?? null,
    slotLabel: item.slotLabel,
    groupLabel: group.groupLabel,
  };
}
